import { LoaderSVG } from '@/Component/Common/SVGs/CommonSVG'
import { useTranslation } from '@/Utils/Hooks/useTranslate';

const ExportLoader = () => {
    const { translations } = useTranslation();
    return (
        <div className='fixed left-0 right-0 bottom-0 top-0 w-full h-full backdrop-blur-sm bg-black/75 z-[100] flex items-center justify-center flex-col gap-5'>
            <LoaderSVG />
            <span className='text-lg font-medium tracking-wide text-white'>{translations?.exportingLoaderText}</span>
        </div>
    )
}

export default ExportLoader
